export const MOBILE_USER_TRACKING_STATUS_MAP: Record<string, string> = {
  available: "Active",
  not_available: "Not available",
  denied: "Denied",
  not_provided_in_use: "Permissions required",
  not_provided_always: "Permissions required",
};
